import React, { FC, useRef } from 'react';

import { Step } from 'src/common/interfaces/step.interface';
import { ContentAddOptions } from './add-options';
import { functionNoop } from 'src/utils/function/noop';
import { StepStrongIcon } from 'src/monet/icons';

interface ContentCardNewProps {
  onClick: () => void;
}

export const ContentCardNew: FC<ContentCardNewProps> = ({ onClick }) => {
  return (
    <button
      type='button'
      className='btn-bedrock-secondary pitch-onboarding-add-step w-[8rem] flex justify-center items-center space-x-xs'
      onClick={onClick}
    >
      <StepStrongIcon />
      <span>Add step</span>
    </button>
  );
};

interface ContentAddNewProps {
  step: Step;
  hasSyncedSteps: boolean;
  onClick: () => void;
}

export const ContentAddNew: FC<ContentAddNewProps> = ({ step, hasSyncedSteps, onClick }) => {
  const addOptionsOpenRef = useRef(functionNoop);
  const addOptionsCloseRef = useRef(functionNoop);

  const onAddClick = () => {
    addOptionsOpenRef.current();
  };

  if (hasSyncedSteps) {
    return (
      <ContentAddOptions
        renderOrigin={() => <ContentCardNew onClick={onAddClick} />}
        openRef={addOptionsOpenRef}
        closeRef={addOptionsCloseRef}
        step={step}
      />
    );
  }

  return <ContentCardNew onClick={onClick} />;
};
